import { render, staticRenderFns } from "./OnboardingProvider.vue?vue&type=template&id=ef41fa12&"
import script from "./OnboardingProvider.vue?vue&type=script&lang=js&"
export * from "./OnboardingProvider.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingProvider.vue?vue&type=style&index=0&id=ef41fa12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports